exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".cut-off-time {\n  padding-bottom: 12px;\n  font-weight: 500;\n  font-size: 12px;\n  font-family: \"DMSans-Medium\";\n  color: #828282; }\n", ""]);

